import { useEffect } from "react";
import Clarity from "@microsoft/clarity";
import { CLARITY_PROJECT_ID } from "@/utils/constants";

/**
 * Microsoft Clarity Provider Component
 * Initializes Clarity analytics on app mount
 * @see https://www.npmjs.com/package/@microsoft/clarity
 */
export default function ClarityProvider() {
  useEffect(() => {
    // Only initialize Clarity if we have a project ID
    if (CLARITY_PROJECT_ID) {
      try {
        Clarity.init(CLARITY_PROJECT_ID);
      } catch (error) {
        console.error("Failed to initialize Microsoft Clarity:", error);
      }
    }
  }, []);

  // This component doesn't render anything visible
  return null;
}
